import React, { useState } from "react";
import axiosInstance from "../../../util/axiosInstance";
import { Apiurl } from "../../../util/apiurl";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

function LogInQuiz() {
  const { id, topic } = useParams();
 
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const handleSignup = async (event) => {
    event.preventDefault(); // Prevent default form submission

    if (!email) {
      setError("Email is required.");
      return;
    }

    setError(""); // Clear error if validation passes

    const totalMarks = localStorage.getItem("totalMarks") || 0; // Retrieve totalMarks from localStorage
    const timeTaken = localStorage.getItem("quizSubmissionTime") || 300;
    const payload = {
      email,
      topicId: id, // Example topicId, replace with appropriate value
      score: Number(totalMarks),
      timeTaken: Number(timeTaken),
    };

    try {
      const response = await axiosInstance.post(Apiurl.logInForm, payload); // Replace with your actual API endpoint
      console.log("Submit response: ", response.data);

      // Check if the user is available
      if (response.data.message === "User not available") {
        setError("User not available");
        return;
      }

      // Handle response or redirect as needed
      setTimeout(() => {
        navigate(`/QuizRank/${id}/${topic}`);
      }, 1000);
    } catch (error) {
      console.error("Error submitting form: ", error);
      setError("User not available");
    }
  };

  const handleSign = () => {
    navigate(`/SignUp/${id}/${topic}`);
  };

  return (
    <>
      <div className="form-main-conatiner">
        <h2>Log in to view your leaderboard rank!</h2>
        <form onSubmit={handleSignup}>
          <div className="input-div">
            <label>
              Email <span>*</span>
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <div className="btn-sec">
            <button type="submit" className="sign-up-btn">
              Login
            </button>
          </div>
        </form>
        <div>
          Not have an account? <button className="log-signup-txt" onClick={handleSign}>Signup</button>
        </div>
      </div>
    </>
  );
}

export default LogInQuiz;
